import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=4f61f3d0&scoped=true"
import script from "./BaseDataTable.vue?vue&type=script&lang=js"
export * from "./BaseDataTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTable.vue?vue&type=style&index=0&id=4f61f3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61f3d0",
  null
  
)

export default component.exports